export default __webpack_public_path__ + "static/media/image-speaker-zx7.173a4cb5.jpg";